(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('tableContribs', tableContribs)
    .directive('contribAuthor', contribAuthor);

    function tableContribs () {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'partials/openstc/contribs_table_directive.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.openstc:interRequester
    * @module swif.openstc
    * @restrict E
    **/
    function contribAuthor(swif) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'partials/openstc/contrib_author_details.html',
            scope: {
                contrib: '='
            },
            link: function(scope, element, attr, ngModel) {
                var user = swif.user.getAuthenticatedUserData();
                scope.fullview = _.contains(user.access_rights, 'openstc_full_view');
                scope.canSee = _.contains(user.access_rights, 'openstc_contrib_see_author') || scope.contrib.create_uid[0] === user.id;

                // Get partner address
                let filter = {};
                swif.data.addFilter(filter, 'user_id', '=', scope.contrib.create_uid[0]);
                swif.data.searchRead('partner_address', filter).then(result => {
                    scope.partnerAddress = result.records[0];
                })
            }
        };
    }

})();
